/** Terms are named A, B, C, D — each costs one query, so the list is short. */
export const TERM_KEYS = ["A", "B", "C", "D"];
export const MAX_TERMS = TERM_KEYS.length;

export const DEFAULTS = {
  terms: [{ filters: [] }, { filters: [] }],
  expression: "A - B",
  valueMode: "count",
};

// What a cell shows: the expression's value as it is, or that value as a
// percentage of what the expression subtracts (B - A → (B - A) / A × 100).
export const VALUE_MODE_OPTIONS = [
  { value: "count", display: "Count change" },
  { value: "percent", display: "Percent change" },
];
